import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';

export default function InboxJobDescriptionModal(props: {
	jobPosition: graphql.JobPosition;
	onDismiss: () => void;
}) {
	const { localize } = useLocalize();

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={props.onDismiss}>
					<ModalHeaderTitle>{localize(props.jobPosition.jobTitle.title).text}</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					{props.jobPosition.jobTitle.description && (
						<QuillText quill={localize(props.jobPosition.jobTitle.description).text} />
					)}
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
